import { useNavigate } from 'react-router-dom';

import Button from 'components/field/Button';
import Card from 'components/global/Card';
import Icon from 'components/global/Icon';
import Typography from 'components/global/Typography';

import PATHS from 'utils/paths';

import { faCircleX } from '@fortawesome/pro-light-svg-icons';

import * as S from './styled/LinkExpired.styled';

const LinkExpired = () => {
	const navigate = useNavigate();

	const handleClose = () => {
		navigate(PATHS.BASE);
	};

	return (
		<S.Wrapper>
			<Card padding={0} background border={0} shadowed rounded>
				<S.Container>
					<Icon icon={faCircleX} color="var(--red)" fontSize="11rem" />
					<Typography variant="p2" fontWeight="700" className="mt-4">
						thisLinkHasExpired
					</Typography>
					<Typography variant="p2" fontWeight="700" className="mb-4 mt-2">
						thisLinkHasExpiredDescription
					</Typography>

					<Button variant="blackOutline" className="btn-close" label="closePage" onClick={handleClose} />
				</S.Container>
			</Card>
		</S.Wrapper>
	);
};

export default LinkExpired;
